import {Component, forwardRef, Inject, OnInit, ChangeDetectorRef} from '@angular/core';
import {provideParent, StateMap, UnitOfWork, UserManager} from '../../services/common';
import {PageState} from '../../controls/common';
import {MaterialFileAction, MaterialFileData, MaterialFileEditData, MaterialFileManagerComponent, MaterialFileType} from './material-file-manager.component';
import * as _ from 'lodash';

export interface FileOption {
    id: number;
    name: string;
}

@Component({
    selector: 'material-file-editor',
    templateUrl: './material-file-editor.html',
    providers: [provideParent(MaterialFileEditorComponent)]
})
export class MaterialFileEditorComponent implements OnInit {

    _pageState = new PageState('Material File Manager');

    // file download links
    _isLoading = false;
    _validationMessage = '';

    _data: MaterialFileEditData;
    _saveData: MaterialFileData;
    private _saveDatadata: any;

    constructor(public _uow: UnitOfWork, public _userManager: UserManager, public _stateMap: StateMap,
                @Inject(forwardRef(() => MaterialFileManagerComponent)) public _parent: MaterialFileManagerComponent, private changeDetectorRef: ChangeDetectorRef) {

        this._data = _parent._data;
        this._saveData = _.clone(this._data.editMaterialFileData);
    }

    ngOnInit() {

    }

    isExpertPanelSummary() {
        return (this._data.editMaterialFileData.fileType == MaterialFileType.EXPERTPANELSUMMARY);
    }

    isFragranceMaterialReview() {
        return (this._data.editMaterialFileData.fileType == MaterialFileType.FRAGRANCEMATERIALREVIEW);
    }

    isMonograph() {
        return (this._data.editMaterialFileData.fileType == MaterialFileType.MONOGRAPH);
    }

    // file editing
    isAdding(): boolean {
        return (this._data.editMaterialFileData != null) ? (this._data.editMaterialFileData.fileAction == MaterialFileAction.ADD) : false;
    }

    isEditing(): boolean {
        return (this._data.editMaterialFileData != null) ? (this._data.editMaterialFileData.fileAction == MaterialFileAction.EDIT) : false;
    }

    isRemoving(): boolean {
        return (this._data.editMaterialFileData != null) ? (this._data.editMaterialFileData.fileAction == MaterialFileAction.DELETE) : false;
    }

    onFileInput(files: FileList) {
        this._validationMessage = '';
        this._data.editMaterialFileData.fileData = files.item(0);

        const fname = files.item(0).name;
        const fext = this.fileExtension(fname);

        this._data.edmMaterialMonograph.currentEntity.fileName = this._data.nextFileName + '.' + fext;

        this._data.hasFileChanges = true;

        // this.changeDetectorRef.detectChanges();
    }

    fileExtension(fileName: string) {
        const fileData = fileName.split('.');

        if (fileData == null || fileData.length < 2) {
            return '';
        }

        return (fileData[1]);
    }
}

